import React, { FC } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { formatDuration } from 'ts/common/videoUtils';

interface Props {
    durationMs?: number;
}

const SlideshowGridItemOverlay: FC<Props> = ({ durationMs }) => {
    return (
        <>
            <Box
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                width="60px"
                height="60px"
                pointerEvents="none"
            >
                <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="30" cy="30" r="30" fill="rgba(255,255,255,0.85)" />
                    <polygon points="24,18 24,42 45,30" fill="rgba(0,0,0,0.75)" />
                </svg>
            </Box>

            {durationMs !== null && durationMs !== undefined && durationMs > 0 && (
                <Box
                    position="absolute"
                    bottom="8px"
                    left="8px"
                    bg="rgba(0, 0, 0, 0.7)"
                    px="6px"
                    py="4px"
                    borderRadius="4px"
                    pointerEvents="none"
                >
                    <Text
                        color="white"
                        fontSize="12px"
                        lineHeight="16px"
                        fontWeight="normal"
                        whiteSpace="nowrap"
                    >
                        {formatDuration(durationMs / 1000)}
                    </Text>
                </Box>
            )}
        </>
    );
};

export default SlideshowGridItemOverlay;
